import {FC, useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import Swal from 'sweetalert2'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Loading} from '../../../components/Loading/Loading'
import {GET, PATCH} from '../../../services/api'

type NoSaleReasonItem = {
  id: number
  slugSaleReasonCode: string
  saleReasonCode: string
}

const normalizeApiData = <T,>(response: any): T => {
  if (response && typeof response === 'object' && 'data' in response) {
    return response.data as T
  }

  return response as T
}

const UpdateSellerNoSaleReasonContent: FC = () => {
  const navigate = useNavigate()
  const {id} = useParams()

  const [loading, setLoading] = useState(false)
  const [slugSaleReasonCode, setSlugSaleReasonCode] = useState('')
  const [saleReasonCode, setSaleReasonCode] = useState('')

  const handleSave = async () => {
    if (!id) {
      return
    }

    setLoading(true)
    try {
      await PATCH(`/seller-no-sale-reason/${id}`, {
        saleReasonCode: saleReasonCode.trim() || undefined,
      })

      Swal.fire({icon: 'success', title: 'Sucesso', text: 'Motivo atualizado com sucesso'}).then(() =>
        navigate('/seller/reason')
      )
    } catch (error: any) {
      Swal.fire({icon: 'error', title: 'Erro', text: String(error || 'Não foi possível atualizar')})
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const loadItem = async () => {
      if (!id) {
        return
      }

      setLoading(true)
      try {
        const response = await GET(`/seller-no-sale-reason/${id}`)
        const item = normalizeApiData<NoSaleReasonItem>(response)

        setSlugSaleReasonCode(item.slugSaleReasonCode || '')
        setSaleReasonCode(item.saleReasonCode || '')
      } catch (error: any) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: String(error || 'Não foi possível carregar o motivo'),
        })
      } finally {
        setLoading(false)
      }
    }

    loadItem()
  }, [id])

  return (
    <div className='row g-5 gx-xxl-12'>
      <div className='card card-xxl-stretch mb-5 mb-xl-12'>
        <div className='card-header py-5'>
          <h3 className='card-title fw-bolder fs-3 mb-0'>Editar Motivo de Não Venda</h3>
        </div>
        <div className='card-body'>
          {loading ? (
            <Loading />
          ) : (
            <div className='d-flex flex-column gap-4'>
              <div>
                <label className='form-label'>Slug</label>
                <input
                  className='form-control'
                  value={slugSaleReasonCode}
                  disabled
                />
              </div>

              <div>
                <label className='form-label'>Descrição</label>
                <input
                  className='form-control'
                  value={saleReasonCode}
                  onChange={(e) => setSaleReasonCode(e.target.value)}
                />
              </div>

              <div className='d-flex gap-2'>
                <button className='btn btn-primary' type='button' onClick={handleSave}>
                  Salvar
                </button>
                <button className='btn btn-light' type='button' onClick={() => navigate('/seller/reason')}>
                  Cancelar
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const EditarSellerNoSaleReason: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Motivos Não Venda', path: '/seller/reason', isActive: false},
          {title: 'Editar Motivo', path: '/seller/reason/edit', isActive: true},
        ]}
      >
        Editar Motivo de Não Venda
      </PageTitle>
      <UpdateSellerNoSaleReasonContent />
    </>
  )
}

export {EditarSellerNoSaleReason}
